var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isAdmin)?_c('div',[_c('AdminList')],1):_c('div',[_c('SellerList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }